export enum RequestAction {
  PromoOnlineRegistration = 'OLRPROMO',
  AmdeaRegistration = 'AMDEA',
  OnlineRegistration = 'OLR',
  SdaOnlineRegistration = 'SDAOLR',
}
